import React from "react";
import HeaderTwo from "../../../components/header/HeaderTwo";
import Footer from "../../../components/footer/Footer";
import Breadcrumb from "./Breadcrumb";
import AboutInner from "./AboutInner";
import LatestMatch from "./LatestMatch";
import CtaArea from "./technology-section";
import EcoSystem from "./eco-system";
import BlogArea from "../../../components/index/indextwo/BlogArea";
import ReleaseGame from "../singlegame/ReleaseGame";
import ShopAreaTwo from "../../../components/index/indextwo/ShopAreaTwo";

function AboutUs() {
  return (
    <>
      <HeaderTwo />
      <main>
        <Breadcrumb />
        <AboutInner />
        <LatestMatch />
        <EcoSystem />
        <CtaArea />
        <BlogArea />
        <ShopAreaTwo/>
        <ReleaseGame />
      </main>
      <Footer />
    </>
  );
}

export default AboutUs;
